import {
  LINKED_PRODUCT_CATEGORY_MESSAGES,
  LinkedProductCategoryMessages,
} from "./linked-product-category.messages";
import { PRODUCT_REQUEST_MESSAGES, ProductRequestMessages } from "./product.request.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import {
  IMAGE_VALIDATION_MESSAGES,
  ImageValidationMessages,
} from "../images/Image-validation.messages";
import { MULTI_SELECT_MESSAGES, MultiSelectMessages } from "../inputs/multi-select.messages";

export type ProductFormMessages = MultiSelectMessages &
  ProductRequestMessages &
  ActionButtonMessages &
  ImageValidationMessages &
  LinkedProductCategoryMessages & {
    // Titles
    categoryTitle: string;
    photosTitle: string;
    productInformationTitle: string;
    additionalInformationTitle: string;
    variationTitle: string;
    productImageTitle: string;

    // Labels messages
    activeLabel: string;
    inactiveLabel: string;

    codeLabel: string;
    externalReferenceLabel: string;
    titleLabel: string;
    shortDescriptionLabel: string;
    videoUrlLabel: string;
    videoUrlTooltip: string;
    descriptionLabel: string;
    brandLabel: string;
    ncmLabel: string;
    variationCodeLabel: string;
    variationsLabel: string;
    warrantyTimeLabel: string;
    pickUpInStoreLabel: string;
    needCommentLabel: string;
    groupVariationsLabel: string;
    groupVariationsTooltip: string;
    groupVariationsDisabledTooltip: string;
    useShortDescriptionInSalesLabel: string;
    useShortDescriptionInSalesTooltip: string;
    rowDateLabel: string;

    // Options
    noProductVariationOption: string;

    // Error messages
    errorRequiredProductCode: string;
    errorRequiredProductTitle: string;
    maximumOfPhotos: string;
    characterLimitExceeded: string;
    charactersRemaining: string;
    errorRemovePhoto: string;
    errorSaveProductBeforeImage: string;
    unsupportedFileFormat: string;
    fileTooLarge: string;
    invalidFileName: string;
    imageDimensionsExceeded: string;
    errorMustHaveAtLeastOneVariation: string; // New error message added

    // Helper messages
    codeCannotBeChanged: string;

    // Success message
    successRemovePhoto: string;

    // New message for no categories
    noCategoriesMessage: string;
    createCategoryButton: string;

    // Buttons messages
    deleteImageButton: string;

    // New message for placeholder
    noVariationsSelected: string;

    errorDescriptionTooLong: string;
    errorShortDescriptionTooLong: string;
    errorRequiredDescription: string;
    errorRequiredShortDescription: string;
  };

export const PRODUCT_FORM_MESSAGES: ProductFormMessages = {
  // Titles
  categoryTitle: "Categorias",
  photosTitle: "Imagens do produto",
  productInformationTitle: "Informações do produto",
  additionalInformationTitle: "Informações Adicionais",
  variationTitle: "Variações",
  productImageTitle: "Imagens do produto",

  // Labels messages
  activeLabel: "Ativo",
  inactiveLabel: "Inativo",
  codeLabel: "Código",
  externalReferenceLabel: "Código Externo",
  titleLabel: "Nome do produto",
  shortDescriptionLabel: "Descrição curta",
  videoUrlLabel: "Link do vídeo",
  videoUrlTooltip: "Informe o link do vídeo do produto (ex.: YouTube). Ele será usado para todas as variações.",
  descriptionLabel: "Descrição longa",
  brandLabel: "Marca",
  ncmLabel: "NCM",
  variationCodeLabel: "Variação",
  variationsLabel: "Variações",
  warrantyTimeLabel: "Garantia",
  pickUpInStoreLabel: "Retire na loja",
  needCommentLabel: "Precisa de comentário",
  groupVariationsLabel: "Agrupar variações na busca",
  groupVariationsTooltip:
    "Quando ativado, o produto será exibido como um único item na busca do agente, agrupando todas as suas variações (cor, tamanho, modelo). O cliente escolherá as variações após selecionar o produto.",
  groupVariationsDisabledTooltip:
    "Disponível apenas para produtos com variações. Este produto é um item único, sem variação (cor, tamanho, modelo).",
  useShortDescriptionInSalesLabel: "Usar descrição curta nas vendas",
  useShortDescriptionInSalesTooltip:
    "Quando ativado, o agente utilizará a descrição curta do produto nas vendas em vez da descrição longa.",
  rowDateLabel: "Data de registro",

  // Options
  noProductVariationOption:
    "Nenhuma variação disponível. Crie uma variação para que ela seja exibida.",

  // Error messages
  errorRequiredProductCode: "O código do produto é obrigatório!",
  errorRequiredProductTitle: "O nome do produto é obrigatório!",
  maximumOfPhotos: "Você pode adicionar no máximo 10 fotos.",
  characterLimitExceeded: "O limite de caracteres foi excedido",
  charactersRemaining: "caracteres restantes",
  errorRemovePhoto: "Erro ao remover a imagem.",
  errorSaveProductBeforeImage: "Erro ao salvar o produto antes de adicionar a imagem.",
  errorMustHaveAtLeastOneVariation:
    "Você deve manter pelo menos uma variação quando há mais de um SKU.",

  // Helper messages
  codeCannotBeChanged: "O código não pode ser alterado após a criação do produto.",

  // Success message
  successRemovePhoto: "Imagem removida com sucesso!",

  // New message for no categories
  noCategoriesMessage: "Nenhuma categoria encontrada",
  createCategoryButton: "Criar Categoria",

  errorDescriptionTooLong: "A descrição ultrapassou o limite de 4096 caracteres.",
  errorShortDescriptionTooLong: "A descrição curta ultrapassou o limite de 500 caracteres.",
  errorRequiredDescription: "A descrição é obrigatória.",
  errorRequiredShortDescription: "A descrição curta é obrigatória.",

  // Buttons messages
  deleteImageButton: "Remover",

  ...IMAGE_VALIDATION_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...PRODUCT_REQUEST_MESSAGES,
  ...MULTI_SELECT_MESSAGES,
  ...LINKED_PRODUCT_CATEGORY_MESSAGES,

  // Placeholder message for MultiSelect
  noVariationsSelected: "Nenhuma variação escolhida",
};
